// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZXQZ","rootNoMargin":"styles_rootNoMargin__3x_xd"};